import { Template } from './Template';
export { Template as StarRating };
//# sourceMappingURL=index.js.map